import * as CL from '@design-system/component-library';
import { t } from '../../common/i18n';

export const PendingInvitationModal = ({ onClose }: { onClose: () => void }) => (
  <CL.Modal
    heading={t.STSD('The user has a pending invitation related to access rights')}
    content={<>{t.WOA2('Access rights cannot be modified because the invitation process is still in progress.')}</>}
    onModalClose={onClose}
    autoOpen
  />
);
